<template>
  <alert-dialog
    centered
    title="Save Workout?"
    :actions="[
      {
        title: 'No',
        callback: handleDismiss
      },
      {
        title: 'Yes, please!',
        callback: handleSignUp
      }
    ]"
    :show="show"
    @close="handleDismiss"
  >
    Save your workout history by creating an account
  </alert-dialog>
</template>

<script>
import { isEmpty } from "@/lib/utils"

import AlertDialog from "@/components/AlertDialog"

export default {
  props: {
    show: { type: Boolean, default: false }
  },

  model: {
    prop: "show",
    event: "change"
  },

  components: {
    AlertDialog
  },

  methods: {
    handleDismiss() {
      this.closePrompt()
      this.$emit("dismiss")
    },

    handleSignUp() {
      this.closePrompt()
      this.$emit("confirm")
      this.$router.push("#auth")
    },

    closePrompt() {
      this.$emit("change", false)
    }
  },

  watch: {
    "$route.hash": function(hash) {
      if (isEmpty(hash)) {
        this.innerShow = false
        this.closePrompt()
      }
    }
  }
}
</script>
